export function createDate(days) {
  let result = new Date();
  result.setDate(result.getDate() + days);
  return result.toISOString().split("T")[0];
}
